import { httpClient } from '@bcba/client-auth';

const basePath = '/public/sign-up';

export const isCompanyFiscalIdAvailable = async (
  fiscalId: number,
): Promise<boolean> => {
  const { data } = await httpClient.get<boolean>(
    `${basePath}/company-fiscal-id-validation/${fiscalId}`,
  );

  return data;
};

export const isCompanyNameAvailable = async (
  fiscalId: string,
): Promise<boolean> => {
  const { data } = await httpClient.get<boolean>(
    `${basePath}/company-name-validation/${fiscalId}`,
  );

  return data;
};
